// extracted by mini-css-extract-plugin
export var videoResponsive = "vimeoEmbed-module--videoResponsive--DPhT7";
export var vimPlayer = "vimeoEmbed-module--vimPlayer--chV15";